import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import {
  Button,
  Col,
  Input,
  Row,
  Select,
  Space,
  Table,
  DatePicker,
  Typography,
  Modal,
  Form,
  Menu,
  Dropdown,
  Checkbox,
  Radio,
  Flex,
  Upload,
  notification,
} from "antd";
import "../Pages/CSS/Traitement.css";
import { JournalCentralService } from "../Services/JournalCentralService";

import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  ExportOutlined,
  ImportOutlined,
  BankOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  MoreOutlined,
  ReloadOutlined,

} from "@ant-design/icons";
import { InterroComptaService } from "../Services/InterroComptaService";
import { TraitementService } from "../Services/TraitementService";
import dayjs from "dayjs";
const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const RappBanque = () => {
  const [form] = Form.useForm();
  const journalCentralService = new JournalCentralService();
  const interroComptService = new InterroComptaService();
  const traitementsoinsService = new TraitementService()
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(null);
  const [years, setYears] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [journalData, setJournalData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectJournal, setSelectJournal] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(/* getCurrentMonth() */null);
  const [paramData, setParamData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [previewData, setPreviewData] = useState([]);

  const [filteredTableData, setFilteredTableData] = useState([]);
  const [typeRapproche, setTypeRapproche] = useState("non");



  const fetchData = async () => {
    if (!selectJournal) return; // Si selectJournal est null, on arrête la fonction
    setIsLoading(true);
    try {
      const yearsData = await journalCentralService.getComptaExercices();
      setYears([...yearsData].sort((a, b) => b - a));

      const listData = await interroComptService.getAllBanques();
      setJournalData(listData);
      if (listData.length > 0 && !selectJournal) {
        setSelectJournal(listData[0].compte); // Initialisation de selectJournal si ce n'est pas déjà fait
      }

      const data = await interroComptService.getListTable(
        typeRapproche,
        selectedYear,
        selectedMonth,
        selectJournal
      );
      setTableData(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectJournal) {
      fetchData();
    }
  }, [typeRapproche, selectJournal, selectedMonth, selectedYear]);


  useEffect(() => {
    setFilteredTableData(tableData);
  }, [tableData]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  const fetchTableData = async () => {
    setIsLoading(true);
    try {
      const rapprochementData = await interroComptService.getRapprochement(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      // Ajoutez ici la variable code_rapp
      const codeRapp = `${selectJournal}${selectedMonth}${selectedYear}`;

      // Incluez la variable code_rapp dans chaque élément de postData
      const postData = rapprochementData.map(data => ({
        ...data,
        code_rapp: codeRapp
      }));

      const addResponse = await interroComptService.addRapprochement(postData);
      console.log("addRapprochement response:", addResponse);

      // Vérifie si l'ajout a été confirmé par le serveur
      if (addResponse && addResponse.Added) {
        const newData = await interroComptService.getListTable(
          typeRapproche,
          selectedYear,
          selectedMonth,
          selectJournal
        );

        // Mettre à jour l'état avec les nouvelles données qui doivent refléter l'état 'Ajout' à 'true'
        setTableData(newData);

      } else {
        console.error("addRapprochement failed or not added:", addResponse);
      }
    } catch (error) {
      console.error("Error during data fetch or update:", error);
    } finally {
      setIsLoading(false);
    }
  };

  /* const fetchDataInit = async () => {
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const monthFromParamData = dayjs(getParam.datedeb).format("MM");
    setSelectedMonth(monthFromParamData);
  }; */
  const fetchDataInit = async () => {
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const monthFromParamData = dayjs(getParam.datedeb).format("MM");
    setSelectedMonth(monthFromParamData);
    const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
    setSelectedYear(yearFromParamData)
    const listData = await interroComptService.getAllBanques();
    if (listData.length > 0) {
      setSelectJournal(listData[0].compte); // Initialisation de selectJournal pour éviter le `null`
    }
  };

  useEffect(() => {
    fetchDataInit();
  }, []);

  const submitDataToAPI = async () => {
    setIsLoading(true);
    try {
      const formattedData = previewData.map(item => ({
        // Supposons que vous avez besoin de reformater les données ici
        datePiece: item.datepiece,  // Assurez-vous que les formats sont corrects
        numPiece: item.numpiece,
        numCheque: item.numcheque,
        libelle: item.libelle,
        debit: parseFloat(item.debit) || 0,  // Convertissez en nombre si nécessaire
        credit: parseFloat(item.credit) || 0,
        solde: parseFloat(item.solde) || 0,
      }));

      const response = await interroComptService.addRapprochement(formattedData);
      console.log("Response:", response);
      refreshData();  // Refresh data to reflect new entries
    } catch (error) {
      console.error("Error during addRapprochement:", error);
    } finally {
      setIsLoading(false);
      setIsModalVisible(false);  // Close the modal after submission
    }
  };


  const handlePlusData = () => {
    fetchTableData();
  };

  const convertSelectedRow = (rows) => {
    let temp = [];
    rows.forEach((element) => {
      temp.push({
        numligne: element?.numligne,
        numligne_rapp: element?.numligne_rapp,
      });
    });
    return temp;
  };

  const handleDelete = async () => {
    const selectedRowsConverted = convertSelectedRow(selectedRows);
    if (selectedRowsConverted.length > 0) {
      setIsLoading(true);
      try {
        const payload = [...selectedRowsConverted];

        console.log(payload);
        const response = await interroComptService.deleteRapprochement(payload);
        console.log("Suppression réussie:", response);
        refreshData();
      } catch (error) {
        console.error("Erreur lors de la suppression :", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Aucune ligne sélectionnée");
    }
  };
  const handleRapproche = async () => {
    const selectedRowskey = filteredTableData.filter((row) =>
      selectedRows.includes(row.numligne_rapp)
    );

    setIsLoading(true);
    try {
      const response = await interroComptService.updateRapprochement(selectedRowskey);
      console.log("Rapprochement réussi:", response);
    } catch (error) {
      console.error("Erreur lors du rapprochement :", error);
    } finally {
      setIsLoading(false);
    }

  };

  const handleAnnuleRapproche = async () => {
    const selectedRowskey = filteredTableData.filter((row) =>
      selectedRows.includes(row.numligne_rapp)
    );

    setIsLoading(true);
    try {
      const response = await interroComptService.updateAnnuleRapprochement(selectedRowskey);
      console.log("Annulation du rapprochement réussie:", response);
      refreshData();
    } catch (error) {
      console.error("Erreur lors de l'annulation du rapprochement :", error);
    } finally {
      setIsLoading(false);
    }

  };


  const handleExcelImport = (file) => {
    console.log("File selected:", file);
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // 'data' now contains the imported Excel data, you can process it as needed
      console.log(data);
    };

    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };



  const previewColumns = [
    {
      title: 'Date pièce',
      dataIndex: 'datepiece',
      key: 'datepiece',
      render: text => (text ? new Date(text).toLocaleDateString("fr-FR") : '') // Formate la date
    },
    {
      title: 'N° pièce',
      dataIndex: 'numpiece',
      key: 'numpiece',
    },
    {
      title: 'N° chèque',
      dataIndex: 'numcheque',
      key: 'numcheque',
    },
    {
      title: 'Libellé',
      dataIndex: 'libelle',
      key: 'libelle',
    },
    {
      title: 'Débit',
      dataIndex: 'debit',
      key: 'debit',
      render: text => text && parseFloat(text).toFixed(2) // Format as decimal
    },
    {
      title: 'Crédit',
      dataIndex: 'credit',
      key: 'credit',
      render: text => text && parseFloat(text).toFixed(2) // Format as decimal
    },
    {
      title: 'Solde bancaire',
      dataIndex: 'solde',
      key: 'solde',
      render: text => text && parseFloat(text).toFixed(2) // Format as decimal
    }
  ];


  const gestionMenu = (
    <Menu>
      <Menu.Item
        icon={<CloudUploadOutlined />}
        onClick={handlePlusData}
        key="1"
      >
        Importer Écritures Comptables
      </Menu.Item>
      <Upload
        beforeUpload={(file) => {
          handleExcelImport(file);
          return false; // Prevent upload
        }}
        accept=".xlsx, .xls"
      >


        <Menu.Item key="2" type="file">

          <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
            <CloudUploadOutlined /> Importer Écritures Bancaires
          </label>

        </Menu.Item>
      </Upload>

    </Menu>
  );
  const gestionMenu1 = (
    <Menu>
      <Menu.Item key="1" onClick={handleRapproche} disabled={typeRapproche === "oui"}>Rapprocher</Menu.Item>
      <Menu.Item key="2" onClick={handleAnnuleRapproche} disabled={typeRapproche === "non"}>Annuler</Menu.Item>
      <Menu.Item key="3">Imprimer État Rapp.</Menu.Item>
    </Menu>
  );
  const onSelectChange = (selectedKeys) => {
    setSelectedRows(selectedKeys);
  };
  /* const rowSelection = {
    selectedRows,
    onChange: onSelectChange,
  }; */
  const allRowKeys = filteredTableData.map((record) => record.numligne_rapp);

  const handleSelectAllChange = (e) => {
    setSelectedRows(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRows,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRows.length === allRowKeys.length}
        indeterminate={selectedRows.length > 0 && selectedRows.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = tableData.map((item) => item.numligne_rapp);
          setSelectedRows(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRows([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.numligne_rapp,
    }),
  };
  const isButtonDisabled = selectedRows.length === 0;


  const exportToExcel = (data, fileName = "export.xlsx") => {
    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };


  const columns = [
    {
      title: "Code J.",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => {
        if (!a.codej && b.codej) return 1;
        if (a.codej && !b.codej) return -1;
        if (!a.codej && !b.codej) return 0;
        return a.codej.localeCompare(b.codej);
      },
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) => {
        const dateA = a.datetrait ? new Date(a.datetrait).getTime() : 0;
        const dateB = b.datetrait ? new Date(b.datetrait).getTime() : 0;
        return dateA - dateB;
      },
    },
    {
      title: "Date pièce",
      dataIndex: "datepiece",
      key: "datepiece",
      align: "center",
      sorter: (a, b) => {
        const dateA = a.datepiece ? new Date(a.datepiece).getTime() : 0;
        const dateB = b.datepiece ? new Date(b.datepiece).getTime() : 0;
        return dateA - dateB;
      },
      render: (text) => text && new Date(text).toLocaleDateString("fr-FR"),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => a.numpiece - b.numpiece,
    },
    {
      title: "N° chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => {
        if (!a.numcheque && b.numcheque) return 1;
        if (a.numcheque && !b.numcheque) return -1;
        if (!a.numcheque && !b.numcheque) return 0;
        return a.numcheque.localeCompare(b.numcheque);
      },
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
      align: "center",
      sorter: (a, b) => {
        if (!a.source && b.source) return 1;
        if (a.source && !b.source) return -1;
        if (!a.source && !b.source) return 0;
        return a.source.localeCompare(b.source);
      },
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => {
        if (!a.libelle && b.libelle) return 1;
        if (a.libelle && !b.libelle) return -1;
        if (!a.libelle && !b.libelle) return 0;
        return a.libelle.localeCompare(b.libelle);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 5,
          }}
        >
          Débit
        </div>
      ),
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit ?? 0) - (b.debit ?? 0),
      render: (text) => (
        <div style={{ paddingRight: 10 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Crédit
        </div>
      ),
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit ?? 0) - (b.credit ?? 0),
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            paddingRight: 10,
          }}
        >
          Solde bancaire
        </div>
      ),
      dataIndex: "solde",
      key: "solde",
      align: "right",
      sorter: (a, b) => (a.solde ?? 0) - (b.solde ?? 0),
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
  ];

  const monthOptions = [
    { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const getJournalLabel = (code) => {
    // Trouve le journal correspondant par codej et retourne son libelle
    const journal = journalData.find((j) => j.compte === code);
    return journal ? journal.intitule : "Journal inconnu"; // Fallback au cas où le code ne correspond à aucun journal
  };

  const totalDebit = filteredTableData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit = filteredTableData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde = totalDebit - totalCredit;

  const refreshData = () => {
    fetchData();
    setSelectJournal("")
    // setSelectedMonth
    setSelectedYear(getSelectedYear())
  };

  const handleTypeChange = (e) => {
    setTypeRapproche(e.target.value);
  };
  return (
    <div>
      <Row gutter={16} style={{ padding: 12 }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 20px",
              background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              marginBottom: 16,
            }}
          >
            <BankOutlined style={{ fontSize: 22, color: "#fff" }} />
            <span
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#fff",
                letterSpacing: 0.5,
                margin: 0,
              }}
            >
              Rapprochement Banques
            </span>
          </div>
          <p>
            <strong>{` ${getJournalLabel(selectJournal)}`}</strong>
            <br />
            <Space>
              <span>
                <strong>Total Débit : {formatNumber(totalDebit)}</strong>
              </span>
              <span>
                <strong>Total Crédit : {formatNumber(totalCredit)}</strong>
              </span>
              <span>
                <strong>Solde : {formatNumber(solde)}</strong>
              </span>
            </Space>
          </p>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "end" }}
        >
          <Row gutter={16}>
            <Space>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" style={{ textAlign: "left" }}>
                  <label>Banques</label>

                  <Select
                    className="select-colored-accent"
                    style={{
                      width: 240,
                      "--select-accent": "#52c41a",
                      "--select-accent-bg": "#f6ffed",
                      "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                    }}
                    value={selectJournal}
                    onChange={setSelectJournal}
                  >
                    {journalData.map((journal) => (
                      <Option key={journal.compte} value={journal.compte}>
                        {journal.compte} - {journal.intitule}
                      </Option>
                    ))}
                  </Select>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" style={{ textAlign: "left" }}>
                  <label>Exercice</label>
                  <Select
                    className="select-colored-accent"
                    style={{
                      width: 100,
                      "--select-accent": "#1890ff",
                      "--select-accent-bg": "#e6f4ff",
                      "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                    }}
                    onChange={handleYearChange}
                    value={selectedYear}
                  >
                    {years.map((year) => (
                      <Option key={year} value={year}>
                        {year}
                      </Option>
                    ))}
                  </Select>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                <Space direction="vertical" style={{ textAlign: "left" }}>
                  <label>Mois</label>

                  <Select
                    className="select-colored-accent"
                    style={{
                      width: 140,
                      "--select-accent": "#722ed1",
                      "--select-accent-bg": "#f9f0ff",
                      "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                    }}
                    onChange={setSelectedMonth}
                    value={selectedMonth}
                  >
                    {monthOptions.map((month) => (
                      <Option key={month.value} value={month.value}>
                        {month.label}
                      </Option>
                    ))}
                  </Select>
                </Space>
              </Col>
            </Space>
          </Row>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12} xl={24}
          style={{ display: "flex", justifyContent: "end", marginBottom: 16 }}
        >
          <Flex wrap="wrap" gap="small">
            <Dropdown overlay={gestionMenu} trigger={["click"]}>

              <Button className="buttonImport" icon={<CloudUploadOutlined />}>
                Importation
                <MoreOutlined />
              </Button>
            </Dropdown>
            <Button
              className="buttonExport"
              onClick={() => exportToExcel(filteredTableData)}
              icon={<CloudDownloadOutlined />}
            >
              Export{" "}
            </Button>

            <Dropdown
              disabled={isButtonDisabled}
              overlay={gestionMenu1}
              trigger={["click"]}
            >
              <Button className="buttonCompta">
                Action <MoreOutlined />
              </Button>
            </Dropdown>
            <Button
              disabled={isButtonDisabled}
              className="buttonClose"
              onClick={handleDelete}
              icon={<DeleteOutlined />}
            >
              Supprimer
            </Button>

            <div style={{ display: "flex", gap: 8 }}>
              {[
                { value: "oui", label: "Écritures Rapprochées" },
                { value: "non", label: "Écritures Non Rapprochées" },
              ].map((item) => (
                <button
                  key={item.value}
                  onClick={() => handleTypeChange({ target: { value: item.value } })}
                  style={{
                    padding: "6px 14px",
                    borderRadius: 20,
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                    background: typeRapproche === item.value
                      ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                      : "#f0f0f0",
                    color: typeRapproche === item.value ? "#fff" : "#595959",
                    boxShadow: typeRapproche === item.value
                      ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                      : "0 1px 3px rgba(0, 0, 0, 0.1)",
                  }}
                  onMouseEnter={(e) => {
                    if (typeRapproche !== item.value) {
                      e.currentTarget.style.background = "#e0e0e0";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (typeRapproche !== item.value) {
                      e.currentTarget.style.background = "#f0f0f0";
                      e.currentTarget.style.transform = "translateY(0)";
                    }
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <Button className="buttonRefresh" onClick={refreshData} icon={<ReloadOutlined />}>
              Actualiser
            </Button>
          </Flex>
        </Col>
      </Row>

      <Table
        loading={isLoading}
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header2-table my-custom-table"
        // permet aussi de maintenir la couleur de la ligne
        rowClassName={(record) =>
          selectedRows.includes(record.numligne_rapp) ? "selected-row" : ""
        }
        bordered
        pagination={{
          pageSize: 10,
        }}
        dataSource={filteredTableData}
        rowSelection={rowSelection}
        columns={columns}
        showSorterTooltip={false}
        rowKey="numligne_rapp"
      />
      <Modal
        title="Aperçu des données à importer"
        open={isModalVisible}
        onOk={submitDataToAPI}  // Cette fonction envoie les données
        onCancel={() => setIsModalVisible(false)}  // Fonction pour fermer le modal
        width={800}
        okText="Importer"  // Personnalisez le texte du bouton si nécessaire
        cancelText="Annuler"
      >
        <Table
          scroll={{ x: true }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          pagination={{
            pageSize: 10,
          }}
          columns={previewColumns}
          dataSource={previewData}

          rowKey="numpiece"
        />
      </Modal>



    </div>
  );
};

export default RappBanque;
